import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ContactsTab } from "./ContactsTab";
import { GroupsTab } from "./GroupsTab";
import { OverdueSettingsTab } from "./OverdueSettingsTab";

export function ContactsModal({ open, onOpenChange, rec, onChanged }) {
  const [tab, setTab] = useState("contacts");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="recurring-contacts-modal">
        <DialogHeader>
          <DialogTitle>Recurring service contacts</DialogTitle>
          <DialogDescription>Vendors and managers who get recurring service reminders. This list is separate from the employee timesheet SMS list — texts only go to people who reply YES to an invite.</DialogDescription>
        </DialogHeader>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList>
            <TabsTrigger value="contacts" data-testid="recurring-tab-contacts">Contacts ({rec.contacts.length})</TabsTrigger>
            <TabsTrigger value="groups" data-testid="recurring-tab-groups">Groups ({rec.groups.length})</TabsTrigger>
            <TabsTrigger value="overdue" data-testid="recurring-tab-overdue">Overdue Notices</TabsTrigger>
          </TabsList>
          <TabsContent value="contacts"><ContactsTab contacts={rec.contacts} onChanged={onChanged} /></TabsContent>
          <TabsContent value="overdue"><OverdueSettingsTab current={rec.status.overdue} onSaved={rec.loadStatus} /></TabsContent>
          <TabsContent value="groups"><GroupsTab groups={rec.groups} contacts={rec.contacts} onChanged={onChanged} /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
